// PDFModal.tsx
import React from "react";
import { Box, Button, Group, Modal } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface PDFModalProps {
  opened: boolean;
  onClose: () => void;
  fileUrl: string;
  onNext?: any;
}

export const PDFModal: React.FC<PDFModalProps> = ({
  opened,
  onClose,
  fileUrl,
  onNext,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t<string>("CONTRACT_INFORMATION")}
      size="lg"
      centered
      styles={{
        body: { padding: 0 },
      }}
    >
      <div style={{ height: "80vh" }}>
        <iframe
          src={`${fileUrl}#toolbar=0`}
          title={t<string>("CONTRACT_INFORMATION")}
          width="100%"
          height="100%"
          style={{ border: "none", overflow: "auto" }}
        />
      </div>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          zIndex: 2,
          padding: "16px",
          backgroundColor: "#fff",
          boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.05)",
          width: "100%",
        }}
      >
        <Group position="right" w="100%">
          <Button
            sx={{
              color: "#525866",
              backgroundColor: "#F4F4F6",
              "&:hover": { backgroundColor: "#F4F4F6" },
              "&:active": { backgroundColor: "#F4F4F6" },
              "&:focus": { outline: "none", boxShadow: "none" },
              padding: "10px 24px",
              borderRadius: "8px",
            }}
            onClick={onClose}
          >
            {t("CANCEL")}
          </Button>

          <Button
            sx={{
              color: "#FDFDFD",
              backgroundColor: "#2A81D0",
              "&:hover": { backgroundColor: "#2A81D0" },
              "&:active": { backgroundColor: "#2A81D0" },
              "&:focus": { outline: "none", boxShadow: "none" },
              padding: "10px 24px",
              borderRadius: "8px",
            }}
            onClick={() => {
              onNext();
              onClose();
            }}
          >
            {t("NEXT")}
          </Button>
        </Group>
      </Box>
    </Modal>
  );
};
